import { AgencyListComponent } from './components/agency-list/agency-list/agency-list.component';
import { AgencyComponent } from './components/agency/agency/agency.component';
import { MinistryListComponent } from './components/ministry-list/ministry-list/ministry-list.component';
import { MinistryComponent } from './components/ministry/ministry/ministry.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import { AuthorizationGuard } from '../authorization/services/authorization.guard';
import { QrCodeSTPComponent } from '../report/qr-code/qr-code.component';
import { BasicProfileComponent } from './components/basic-profile/basic-profile.component';
import { AdminStpEditTabComponent } from './components/admin-stp-edit-tab/admin-stp-edit-tab.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { StpApplicationViewComponent } from './components/stp-application-view/stp-application-view.component';
import { StpApplicationsComponent } from './components/stp-applications/stp-applications.component';
import { StpMainUpdateComponent } from './components/stp-main-update/stp-main-update.component';
import { StpOrganizationRepresentativeComponent } from './components/stp-organization-representative/stp-organization-representative.component';
import { StpPaymentComponent } from './components/stp-payment/stp-payment.component';
import { StpTabComponent } from './components/stp-tab/stp-tab.component';
import { SuccessComponent } from './components/success/success.component';
import { InspectionOfficerListComponent } from './components/inspection-officer/inspection-officer-list/inspection-officer-list.component';
import { AddInspectionOfficerComponent } from './components/inspection-officer/add-inspection-officer/add-inspection-officer.component';
import { ApplicationListStpComponent } from './components/application-list-stp/application-list-stp.component';
import { SetupComponent } from './components/setup/setup.component';
import { CorrectionRequestStpComponent } from './components/correction-request/correction-request-stp/correction-request-stp.component';
import { CorrectionRequestListComponent } from './components/correction-request/correction-request-list/correction-request-list.component';
import { ApproveStpCorrectionRequestComponent } from './components/correction-request/approve-stp-correction-request/approve-stp-correction-request.component';
import { SentForCorrectionsListComponent } from './components/correction-request/sent-for-corrections-list/sent-for-corrections-list.component';
import { PreviousStpApplicationViewComponent } from "./components/previous-stp-application-view/previous-stp-application-view.component";
import { ScheduleInspectionComponent } from './components/stp-inspection/schedule-inspection/schedule-inspection.component';
import { CompleteInspectionComponent } from './components/stp-inspection/complete-inspection/complete-inspection.component';
import { ScrutinyResultComponent } from './components/stp-inspection/scrutiny-result/scrutiny-result.component';
import { StpSacInspectionReportPreviewComponent } from './components/stp-inspection/stp-sac-inspection-report-preview/stp-sac-inspection-report-preview.component';
import { DecisionComponent } from './components/stp-inspection/decision/decision.component';
import { StpSacInspectionReportComponent } from './components/stp-inspection/stp-sac-inspection-report/stp-sac-inspection-report.component';
import {
  PreviousStpApplicationComponent
} from "./components/previous-stp-application/previous-stp-application.component";
import { StpActivityLogComponent } from './components/stp-activity-log/stp-activity-log.component';
import { StpRenewReapplyTabComponent } from './components/renew-reapply/components/stp-renew-reapply-tab/stp-renew-reapply-tab.component';
import { StpApplicationViewRenewReapplyComponent } from './components/renew-reapply/components/stp-application-view-renew-reapply/stp-application-view-renew-reapply.component';
import { StpRenewalApplicationListComponent } from './components/renew-reapply/components/stp-renewal-application-list/stp-renewal-application-list.component';
import { InspectionSchedulingComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/inspection-scheduling/inspection-scheduling.component';
import { InspectionCompletionComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/inspection-completion/inspection-completion.component';
import { ResultScrutinyComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/result-scrutiny/result-scrutiny.component';
import { FinalDecisionComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/final-decision/final-decision.component';
import { StpSacInspectionRenewReapplyComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/stp-sac-inspection-renew-reapply/stp-sac-inspection-renew-reapply.component';
import { StpSacInsPreviewRenewReapplyComponent } from './components/renew-reapply/components/stp-renew-reapply-inspections/stp-sac-ins-preview-renew-reapply/stp-sac-ins-preview-renew-reapply.component';
import { StpReapplyApplicationListComponent } from './components/renew-reapply/components/stp-reapply-application-list/stp-reapply-application-list.component';
import { StpRenewReapplyArchiveListComponent } from './components/renew-reapply/components/stp-renew-reapply-archive-list/stp-renew-reapply-archive-list.component';
import { StpArchiveApplicationViewRenewReapplyComponent } from './components/renew-reapply/components/stp-archive-application-view-renew-reapply/stp-archive-application-view-renew-reapply.component';

const routes: Routes = [
  {
    path: 'basic-Profile',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.basicProfile.readPermission,
    }, //'basic-Profile' },
    canActivate: [AuthorizationGuard],
    component: BasicProfileComponent,
  },
  {
    path: 'payment',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpPayment.readPermission,
    }, //'payment' },
    canActivate: [AuthorizationGuard],
    component: StpPaymentComponent,
  },
  {
    path: 'dash-board',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.dashBoard.readPermission,
    }, // 'dash-board' },
    component: StpTabComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'edit-dash-board/:userId',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.dashBoard.readPermission,
    },
    component: StpTabComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'dash-board/admin-stp-edit/:userId',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.dashBoard.readPermission,
    },
    component: AdminStpEditTabComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'admin-stp-edit/:userId',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.dashBoard.readPermission,
    },
    component: AdminStpEditTabComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'renew-reapply-dash-board',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.dashBoard.readPermission,
    },
    component: StpRenewReapplyTabComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'success',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpSuccess.readPermission,
    }, // 'success' },
    canActivate: [AuthorizationGuard],
    component: SuccessComponent,
  },
  {
    path: 'stp-applications',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpApplication.readPermission,
    },
    component: StpApplicationsComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'stp-application/:countType',
    data: {
      permissionName:
      applicationPermissions.stpRegistration.stpApplication.readPermission,
    },
    component: StpApplicationsComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'previous-stp-applications-admin',
    data: { permissionName: applicationPermissions.stpRegistration.stpApplication.menuPreviousStpApplicationListPermission },
    component: PreviousStpApplicationComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'stp-application-view/:id',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpApplicationView
          .readPermission,
    },
    canActivate: [AuthorizationGuard],
    component: StpApplicationViewComponent,
  },
  {
    path: 'stp-application-view-renew-reapply',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpApplicationView
          .readPermission,
    },
    canActivate: [AuthorizationGuard],
    component: StpApplicationViewRenewReapplyComponent,
  },
  {
    path: 'stp-archive-application-view-renew-reapply',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpRenewReapplyArchiveListPermission,
    },
    canActivate: [AuthorizationGuard],
    component: StpArchiveApplicationViewRenewReapplyComponent,
  },
  {
    path: 'previous-stp-application-view/:id/:applicationId',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpApplicationView
          .readPermission,
    },
    canActivate: [AuthorizationGuard],
    component: PreviousStpApplicationViewComponent,
  },
  {
    path: 'stp-name-update/:id',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.stpApplication
          .updateSTPNamePermission,
    },
    canActivate: [AuthorizationGuard],
    component: StpMainUpdateComponent,
  },
  {
    path: 'stp-organization-address-update/:id',
    data: {
      permissionName:
        applicationPermissions.stpRegistration.basicProfile
          .updateBasicProfileOrganizationDetails,
    },
    canActivate: [AuthorizationGuard],
    component: StpOrganizationRepresentativeComponent,
  },

  { path: 'otp-verification', component: OtpVerificationComponent },
  {
    path: 'otp-verification',
    data: { permissionName:  applicationPermissions.stpRegistration.otpVerification.readPermission},// 'otp-verification' },
    canActivate: [AuthorizationGuard],
    component: OtpVerificationComponent,
  },

  {
    path: 'qr-code',
    data: { permissionName: applicationPermissions.stpRegistration.qrCode.readPermission },//'qr-code' },
    canActivate: [AuthorizationGuard],
    component: QrCodeSTPComponent,
  },
  { path: 'add-ministry', component: MinistryComponent },
  { path: 'add-ministry/:id', component: MinistryComponent },
  { path: 'ministry-list', component: MinistryListComponent },
  { path: 'add-agency', component: AgencyComponent },
  { path: 'agency-list', component: AgencyListComponent },
  { path: 'add-agency/:id', component: AgencyComponent },
  { path: 'inspection-officer-list', component: InspectionOfficerListComponent },
  { path: 'add-inspection-officer/:id', component: AddInspectionOfficerComponent },
  // STP user lists: one screen, four modes
  { path: 'application-list-stp', component: ApplicationListStpComponent, data: { listType: 'application' } },
  // The STP's renewal / reapply application is shown in its Application List; old links redirect there
  { path: 'application-list-stp/renewal', redirectTo: 'application-list-stp', pathMatch: 'full' },
  { path: 'application-list-stp/reapply', redirectTo: 'application-list-stp', pathMatch: 'full' },
  { path: 'application-list-stp/archive', component: ApplicationListStpComponent, data: { listType: 'archive' } },
  { path: 'setup', component: SetupComponent },
  { path: 'stp-correction-request/:id', component: CorrectionRequestStpComponent },
  { path: 'sent-for-corrections', component: SentForCorrectionsListComponent },
  { path: 'correction-request-list', component: CorrectionRequestListComponent },
  { path: 'approve-stp-correction-request/:id', component: ApproveStpCorrectionRequestComponent },
  { path: 'schedule-inspection/:inspectionId', component: ScheduleInspectionComponent },
  { path: 'complete-inspection/:inspectionId', component: CompleteInspectionComponent },
  { path: 'scrutiny-result/:inspectionId', component: ScrutinyResultComponent },
  { path: 'decision/:inspectionId', component: DecisionComponent },
  { path: 'stp-sac-inspection-report/:inspectionId', component: StpSacInspectionReportComponent },
  { path: 'stp-sac-inspection-report-preview/:inspectionId', component: StpSacInspectionReportPreviewComponent },
  { path: 'stp-activity-log', component: StpActivityLogComponent },

  {
    path: 'stp-renewal-application-list',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpRenewalApplicationListAdmin },
    canActivate: [AuthorizationGuard],
    component: StpRenewalApplicationListComponent,
  },
  {
    path: 'stp-reapply-application-list',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpReapplyApplicationListAdmin },
    canActivate: [AuthorizationGuard],
    component: StpReapplyApplicationListComponent,
  },
  // same lists, limited to the applications assigned to the logged-in NSDA officer
  {
    path: 'assigned-stp-renewal-application-list',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpRenewalApplicationList, assignedOnly: true },
    canActivate: [AuthorizationGuard],
    component: StpRenewalApplicationListComponent,
  },
  {
    path: 'assigned-stp-reapply-application-list',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpReapplyApplicationList, assignedOnly: true },
    canActivate: [AuthorizationGuard],
    component: StpReapplyApplicationListComponent,
  },
  {
    path: 'inspection-scheduling/:stpMainId/:type',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.inspectionSchedulingRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: InspectionSchedulingComponent,
  },
  {
    path: 'inspection-completion/:inspectionId/:type',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.inspectionCompletionRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: InspectionCompletionComponent,
  },
  {
    path: 'result-scrutiny/:inspectionId/:type',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.resultScrutinyRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: ResultScrutinyComponent,
  },
  {
    path: 'final-decision/:inspectionId/:type',
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.finalDecisionRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: FinalDecisionComponent,
  },
  { path: 'stp-sac-inspection-report-renew-reapply/:inspectionId', 
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.inspectionCompletionRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: StpSacInspectionRenewReapplyComponent },
    
  { path: 'stp-sac-inspection-report-preview-renew-reapply/:inspectionId', 
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.resultScrutinyRenewReapplyButtonPermission },
    canActivate: [AuthorizationGuard],
    component: StpSacInsPreviewRenewReapplyComponent },

  { path: 'stp-renew-reapply-archive-list', 
    data: { permissionName: applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpRenewReapplyArchiveListPermission },
    canActivate: [AuthorizationGuard],
    component: StpRenewReapplyArchiveListComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StpRegistrationRoutingModule { }
